"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var apollo_link_1 = require("apollo-link");
var apollo_link_batch_http_1 = require("apollo-link-batch-http");
var apollo_link_http_1 = require("apollo-link-http");
var apollo_upload_client_1 = require("apollo-upload-client");
var subscriptionLink_1 = require("./subscriptionLink");
function createNetworkLink(_a) {
    var endpoint = _a.endpoint, _b = _a.useBatching, useBatching = _b === void 0 ? true : _b, _c = _a.useUploads, useUploads = _c === void 0 ? false : _c;
    var options = {
        uri: endpoint + "/graphql",
        credentials: 'same-origin',
    };
    var httpLink = apollo_link_1.ApolloLink.split(function (op) {
        var context = op.getContext();
        return useBatching && context.noBatch !== true;
    }, new apollo_link_batch_http_1.BatchHttpLink(options), useUploads ? apollo_upload_client_1.createUploadLink(options) : apollo_link_http_1.createHttpLink(options));
    var subscriptionLink = subscriptionLink_1.createSubscriptionLink(endpoint);
    return apollo_link_1.ApolloLink.split(subscriptionLink_1.isSubscriptionOperation, subscriptionLink, httpLink);
}
exports.createNetworkLink = createNetworkLink;
/**
 * Some operations might have bigger priority and should complete as soon as
 * possible. If they are batched, they would have to wait for other operations
 * to complete as well.
 *
 * Using context the batching can be disabled per operation. Simply spread this
 * object over operation options.
 *
 * @example
 * useQUser({ userId }, disableBatching)
 * useQUser({ userId }, { skip: !userId, ...disableBatching })
 */
exports.disableBatching = {
    context: {
        noBatch: true,
    },
};
//# sourceMappingURL=createNetworkLink.js.map